import React, { useState } from 'react';
import { TelemetryContext } from './TelemetryContext';
export function TelemetryProvider({ children, telemetryConfig: initialConfig }) {
    const [telemetryConfig, setTelemetryConfig] = useState(initialConfig);
    return (React.createElement(TelemetryContext.Provider, { value: { telemetryConfig, setTelemetryConfig } }, children));
}
